import {
  InvoiceAccountBU,
  InvoiceAccountBUData,
  InvoiceDirection,
} from "@/apps/tatar/invoiceApp/RAInterfaces";
import FormStruct from "@/components/Form/FormStruct/FormStruct";
import { FV } from "@/components/Form/Validation/FormValidators";
import ModalManager from "@/components/ModalComponent/ModalManager";
import i18n from "@/i18n";
import BFInput from "@/modules/abstract-ui/forms/input/BFInput";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import classNames from "classnames";
import { useState } from "react";
import { Field } from "react-final-form";
import RACService from "../../RACService";
// import './RACAccountBUForm.scss';

interface RACAccountBUFormProps {
  entityId: string;
  direction: InvoiceDirection;
  accountBU?: InvoiceAccountBU;
  onClose: () => void;
  onSubmit: (data: InvoiceAccountBU) => void;
  initialValues?: Partial<InvoiceAccountBUData>;
}
const RACAccountBUForm = (props: RACAccountBUFormProps) => {
  const [initialState] = useState<InvoiceAccountBUData>(
    props.accountBU
      ? {
          // direction: props.account.data.direction,  //todo add direction to account
          entity: props.accountBU.data.entity,
          accountNumber: props.accountBU.data.accountNumber,
          description: props.accountBU.data.description,
          status: props.accountBU.data.status,
          ust: props.accountBU.data.ust,
        }
      : {
          // direction: props.invoiceDirection,  //todo add direction to account
          entity: props.entityId,
          accountNumber: "",
          description: "",
          ust: 0,
          status: "active",
          ...(props.initialValues || {}),
        }
  );
  return (
    <FormStruct<InvoiceAccountBUData>
      className={classNames("rac-account-bu-form")}
      submitText={
        props.accountBU
          ? i18n.t("Global.Buttons.save")
          : i18n.t("Global.Buttons.create")
      }
      onSubmit={async (values) => {
        let result;
        if (props.accountBU) {
          result = await RACService.updateInvoiceAccountBU(
            props.accountBU._id,
            values
          );
        } else {
          result = await RACService.createInvoiceAccountBU(values);
        }

        props.onSubmit(result);
      }}
      initialValues={initialState}
      title={
        props.accountBU
          ? i18n.t("rac:Accounts.AccountForm.editTitle", "Konto bearbeiten")
          : i18n.t("rac:Accounts.AccountForm.createTitle", "Konto erstellen")
      }
      additionalActions={
        props.accountBU ? (
          <>
            <BFButton
              onClick={() => {
                ModalManager.confirm({
                  message: i18n.t(
                    "rac:Accounts.AccountForm.archiveConfirm",
                    "Möchten Sie das Konto wirklich archivieren?"
                  ),
                  confirmButtonText: i18n.t(
                    "Global.Buttons.archive",
                    "Archivieren"
                  ),
                  onConfirm: async () => {
                    const result = await RACService.archiveInvoiceAccountBU(
                      props.accountBU
                    );
                    props.onSubmit(result);
                  },
                });
              }}
              appearance="outline"
            >
              {i18n.t("rac:Accounts.AccountForm.archive", "Konto archivieren")}
            </BFButton>
          </>
        ) : null
      }
      onAbort={props.onClose}
      render={(formProps) => (
        <>
          <Field name="accountNumber" validate={FV.required()}>
            {({ input, meta }) => (
              <div className={`__field`}>
                <BFInput
                  {...input}
                  {...FV.getValidation(meta)}
                  label={i18n.t(
                    "rac:Accounts.AccountForm.accountNumber",
                    "Kontonummer"
                  )}
                  placeholder={i18n.t(
                    "rac:Accounts.AccountForm.accountNumber",
                    "Kontonummer"
                  )}
                />
              </div>
            )}
          </Field>
          <Field name="description" validate={FV.required()}>
            {({ input, meta }) => (
              <div className={`__field`}>
                <BFInput
                  {...input}
                  {...FV.getValidation(meta)}
                  label={i18n.t(
                    "rac:Accounts.AccountForm.description",
                    "Kontoname"
                  )}
                  placeholder={i18n.t(
                    "rac:Accounts.AccountForm.description",
                    "Kontoname"
                  )}
                />
              </div>
            )}
          </Field>
          <Field name="ust">
            {({ input, meta }) => (
              <div className={`__field`}>
                <BFInput
                  {...input}
                  {...FV.getValidation(meta)}
                  type="number"
                  prefix="%"
                  label={i18n.t("rac:Accounts.AccountForm.ust", "Steuersatz")}
                  placeholder={i18n.t(
                    "rac:Accounts.AccountForm.ust",
                    "Steuersatz"
                  )}
                />
              </div>
            )}
          </Field>
        </>
      )}
    />
  );
};

export default RACAccountBUForm;
